import { render, staticRenderFns } from "./psc-box1.vue?vue&type=template&id=02036baa&scoped=true&"
import script from "./psc-box1.vue?vue&type=script&lang=js&"
export * from "./psc-box1.vue?vue&type=script&lang=js&"
import style0 from "./psc-box1.vue?vue&type=style&index=0&id=02036baa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02036baa",
  null
  
)

export default component.exports